import { images } from "../../config/images";
import { siteContent } from "../../content/siteContent";
import { ResponsiveImage } from "./ResponsiveImage";

export function About() {
  const { about } = siteContent;

  return (
    <section id={about.id} className="home-about home-section" aria-labelledby="home-about-title">
      <div className="home-shell">
        <div className="home-about__heading">
          <p className="home-eyebrow">{about.eyebrow}</p>
          <h2 id="home-about-title">
            {about.titleLines.map((line) => (
              <span key={line}>{line}</span>
            ))}
          </h2>
        </div>

        <div className="home-about__composition">
          <figure className="home-about__primary-figure">
            <ResponsiveImage
              image={images.aboutPrimary}
              className="home-about__primary-image"
              sizes="(min-width: 960px) 44vw, 100vw"
            />
          </figure>

          <figure className="home-about__secondary-figure">
            <ResponsiveImage
              image={images.aboutSecondary}
              className="home-about__secondary-image"
              sizes="(min-width: 960px) 24vw, 52vw"
            />
            <figcaption>{about.imageNote}</figcaption>
          </figure>

          <div className="home-about__copy">
            <h3 className="home-about__story-title">{about.storyTitle}</h3>
            {about.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
